import { Location } from "@insite/client-framework/Components/SpireRouter";
/* eslint-disable no-return-assign */
import { Paths, RouteProvider } from "@sonic-equipment/ui";
// eslint-disable-next-line spire/fenced-imports

import HistoryContext from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";

const PATHS = {
    MY_SONIC: "/MyAccount",
    UPLOAD_ORDER: "/MyAccount/UploadOrder",
    ACCOUNT_ADDRESSES: "/MyAccount/Addresses",
    ACCOUNT_CREATE: "/MyAccount/CreateAccount",
    ACCOUNT_INVOICES: "/MyAccount/Invoices",
    ACCOUNT_MY_LISTS: "/MyAccount/MyLists",
    ACCOUNT_ORDERS: "/MyAccount/Orders",
    ACCOUNT: "/MyAccount",
    CART: "/Cart",
    CHECKOUT_SHIPPING: "/CheckoutShipping",
    CHECKOUT_SHIPPING_VIA_SIGNIN: "/SignIn?returnUrl=/CheckoutShipping",
    FAVORITES: "/MyAccount/MyLists",
    HOME: "/",
    ORDER_CONFIRMATION: "/OrderConfirmation",
    REVIEW_AND_SUBMIT: "/CheckoutReviewAndSubmit",
    SIGN_IN: "/SignIn",
    ACCOUNT_EDIT_BILL_TO_ADDRESS: "/",
    ACCOUNT_EDIT_SHIP_TO_ADDRESS: "/",
} as const satisfies Paths;

export function ReduxRouteProvider({ children, location }: { children: React.ReactNode; location: Location }) {
    return (
        <HistoryContext.Consumer>
            {({ history }) => (
                <RouteProvider
                    paths={PATHS}
                    url={{
                        pathname: location.pathname,
                        href: `${location.pathname}${location.search}`,
                        search: location.search,
                    }}
                    navigate={(href, options) => {
                        if (href.toLowerCase().startsWith("http") || options?.reload) {
                            if (typeof window === "undefined") {
                                return;
                            }
                            return (window.location.href = href);
                        }
                        return history.push(href, options);
                    }}
                >
                    {children}
                </RouteProvider>
            )}
        </HistoryContext.Consumer>
    );
}
